@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../app-brand/concepts/shipstation-concept-layer-default.module.less';

@BatchListItem_Selected: {
  &.selected {
    background: var(--add-to-batch-menu--batch-list-item--selected--background-color);
    color: var(--add-to-batch-menu--batch-list-item--selected--text-color);

    .count {
      color: var(--add-to-batch-menu--count-pill--selected--text-color);
      border-radius: 16px;
      border: 1px solid var(--add-to-batch-menu--count-pill--selected--border-color);
      background: var(--add-to-batch-menu--count-pill--selected--background-color);
    }
  }
};

.batch-item-wrapper {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  min-height: 32px;
}

.batch-list-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: @space-4;
  width: 100%;
  padding: @space-4 @space-0 @space-4 38px;

  color: var(--add-to-batch-menu--text-color);
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  overflow-x: hidden;

  .name-and-date {
    flex: 0 1 85%;
    text-align: left;
    overflow-x: hidden;
  }

  .count {
    display: flex;
    min-width: 20px;
    width: fit-content;
    min-height: 20px;
    padding: @space-0 @space-8;
    justify-content: center;
    align-items: center;
    gap: @space-4;

    color: var(--add-to-batch-menu--count-pill--text-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;

    border-radius: 16px;
    background: var(--add-to-batch-menu--count-pill--background-color);
  }

  @BatchListItem_Selected();
}
